import BaseComponent from '../../../../../common/js/BaseComponent';

export default class Header extends BaseComponent {
    searchModalElement: HTMLElement | null;

    mobileNavModalElement: HTMLElement | null;

    shopsModalElement: HTMLElement | null;

    boundSearchEventHandler: any;

    protected initAdditionalVar() {
        this.searchModalElement = document.getElementById('searchModal');
        this.mobileNavModalElement = document.getElementById('mobileNav');
        this.shopsModalElement = document.getElementById('choose-shop');
    }

    init(): any {
        // A l'affichage des modales de recherche en desktop (searchModal) et de navigation mobile (mobileNav)
        // on initialise un listener qui va permettre de fermer et vider les champs de recherche et suggestions
        // qui sont dans les modales
        this.onSearchModalShown();
        this.onMobileNavModalHidden();
        this.onLoadSiteGroupeEcommerce();
    }

    onSearchModalShown() {
        if (this.searchModalElement) {
            this.searchModalElement.addEventListener('shown.bs.modal', () => {
                this.boundSearchEventHandler = this.searchModalBackdropHandler.bind(this);
                document.addEventListener('click', this.boundSearchEventHandler, false);
            });
        }
    }

    /**
     * Affichage de la modale de choix d'une agence si pas de currentShop stocké en session
     */
    onLoadSiteGroupeEcommerce() {
        if (this.shopsModalElement) {
            const currentShop = this.shopsModalElement.getAttribute('data-current-shop');
            if (!currentShop) {
                $('#choose-shop').modal('show');
            }
        }
    }

    /**
     * A la fermeture de la modale de navigation sur mobile, on vide les suggestions et le champ de recherche
     */
    onMobileNavModalHidden() {
        if (this.mobileNavModalElement) {
            this.mobileNavModalElement.addEventListener('hide.bs.modal', () => {
                this.cleanSearchFields();
                this.cleanSuggestedProductsContainers();
            });
        }
    }

    searchModalBackdropHandler(e: MouseEvent) {
        if (e !== null && e.target !== null) {
            const element = e.target as Element;
            const isMatch = element.matches('input, button');
            if (!isMatch) {
                this.hideModalElement(this.searchModalElement);
                this.cleanSearchFields();
                this.cleanSuggestedProductsContainers();
                this.removeSearchModalBackdropListener();
            }
        }
    }


    /**
     * Nettoie le contenu des 2 champs de recherches presents sur la page, celui de la modale de recherche
     * et celui de la modale de navigation mobile.
     */
    cleanSearchFields() {
        // Il y a 2 champs de recherche, l'un en navigation mobile avec le reste du burger menu et l'autre
        // dans la modale de recherche qui est accessible en navigation desktop.
        const searchFields = this.view.querySelectorAll('.input-search-field');
        searchFields.forEach((item: HTMLInputElement) => {
            item.value = '';
        });
    }

    /**
     * Nettoie le contenu des 2 conteneurs de suggestions de produits du moteur de recherche presents sur
     * la page, celui de la modale de recherche et celui de la modale de navigation mobile.
     */
    cleanSuggestedProductsContainers() {
        // Il y a 2 conteneurs de suggestion de produits, l'un en navigation mobile avec le reste du burger
        // menu et l'autre dans la modale de recherche qui est accessible en navigation desktop.
        const containers = this.view.querySelectorAll('.suggested-products-container');
        containers.forEach((item) => {
            item.innerHTML = '';
        });
    }

    /**
     * Cache la modale transmise en parametre.
     * @param modalElement
     */
    hideModalElement(modalElement?: any) {
        if (modalElement) {
            const modal = window.bootstrap.Modal.getInstance(modalElement);
            if (modal) {
                modal.hide();
            }
        }
    }

    removeSearchModalBackdropListener() {
        document.removeEventListener('click', this.boundSearchEventHandler, false);
    }

}
